export enum BannerMode {
  Error = 'Error',
  Warning = 'Warning',
}
